const Copyrite = () => {
    return (
        <footer className="footer mt-auto">
            <p className="m-0">&copy; Nigeria Customer Service Index - All Rights Reserved.</p>
        </footer>
    )
}

export default Copyrite;
